import{__assign as t}from'./../ext/tslib/tslib.es6.js';import i from"react";import{Pagination as o}from"./NumericPagination/Pagination.js";var r=function(r){return i.createElement(o,t({},r))};export{r as Pagination};
//# sourceMappingURL=Pagination.js.map
